export default __webpack_public_path__ + "static/img/lens.3b572e7.png";